export const GMAIL = 'GMAIL';
export const OUTLOOK365 = 'OUTLOOK365';